<style lang="less" scoped>
.menuItem {
  line-height: 3em;
  width: 100%;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    background-color: #dddddd;
  }
  &.active {
    background-color: #cccccc;
  }
}
.person_Center {
  width: 1440px;
  //   height: calc(100% - 120px);
  // background-color: #fff;
  display: flex;
  margin: 20px auto;
  background: #eeeeee;
  height: 1100px;

  //   .center_left {
  //     width: 410px;
  //     padding: 0 40px;
  //     border-right: 1px solid #ccc;
  //     .headImg {
  //       width: 126px;
  //       height: 126px;
  //       border-radius: 50%;
  //       margin: 20px 0;
  //       img {
  //         width: 126px;
  //         height: 126px;
  //         border-radius: 50%;
  //       }
  //     }
  //     .userName {
  //       font-size: 30px;
  //       text-align: left;
  //       padding: 20px 0;
  //     }
  //     .person_userInfo {
  //       text-align: left;
  //       // padding: 0 40px;
  //       li {
  //         line-height: 34px;
  //         &.guiguiWallet {
  //           span {
  //             color: #6851ff;
  //             font-weight: bold;
  //           }
  //         }
  //       }
  //     }
  //     .manageAddress {
  //       display: flex;
  //       align-items: center;
  //       justify-content: space-between;
  //       margin: 40px 0 0;
  //       .addressInput {
  //         background-color: #fff;
  //         border: 1px solid #6851ff;
  //         width: 200px;
  //         height: 36px;
  //         text-align: left;
  //         padding: 0 6px 0 10px;
  //         display: flex;
  //         align-items: center;
  //         border-radius: 8px;
  //         input {
  //           width: 100%;
  //           height: 30px;
  //           border: none;
  //           outline: none;
  //           background-color: #fff;
  //           font-size: 18px;
  //           color: #4d4d4d;
  //         }
  //       }
  //       .nowAddress {
  //         font-size: 18px;
  //         background-color: #ebebeb;
  //         border: 1px solid rgba(221, 221, 221, 1);
  //         width: 200px;
  //         height: 36px;
  //         line-height: 36px;
  //         text-align: left;
  //         padding: 0 6px 0 10px;
  //         border-radius: 8px;
  //       }
  //       .btn {
  //         cursor: pointer;
  //         color: #6851ff;
  //       }
  //     }
  //     .downApp {
  //       margin: 20px 0 40px;
  //       display: flex;
  //       justify-content: space-between;
  //       .downBtn {
  //         color: #6851ff;
  //         cursor: pointer;
  //       }
  //     }
  //     .logout {
  //       cursor: pointer;
  //       text-align: left;
  //       padding: 20px 0;
  //       font-size: 18px;
  //       color: #6851ff;
  //     }
  //   }
  .person_left_top {
    width: 300px;
    height: 430px;
    background-color: #ffffff;
    border-radius: 10px;
    font-size: 15px;
  }
  .logout {
    display: inline-block;
    cursor: pointer;
  }
  .infoAndQuit {
    margin: 16px 11px 19px 12px;
    display: flex;
    justify-content: space-between;
  }
  .quitImg {
    width: 18px;
    height: 18px;
  }
  .quit {
    font-size: 14px;
  }
  .headImg {
    width: 126px;
    height: 126px;
    margin: 0 auto;
  }
  .userImg {
    width: 126px;
    height: 126px;
    border-radius: 50%;
    border: 0.5px solid rgba(0, 0, 0, 0.1);
  }
  .yellowDiamond,
  .silverDiamond {
    width: 18px;
    height: 16px;
  }
  .userName {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    font-family: PingFang SC;
  }
  .vip {
    font-family: PingFang SC;
    font-size: 15px;
    font-weight: 400;
  }
  .color_2 {
    color: #9b6a0f;
  }
  .userNameAndVip {
    margin-top: 9px;
  }
  .userNameAndVip > p {
    margin-bottom: 8px;
  }
  .changeIndentityBox {
    margin-top: 10px;
    display: flex;
    align-items: center;
    padding: 0 12px;
  }
  .changeIndentityBox > span {
    font-size: 16px;
    color: #333333;
  }
  .changeIndentityBox > div select {
    border: 1px solid #aaa;
    min-width: 60px;
    max-width: 120px;
    overflow: hidden;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    outline: none;
    display: inline-block;
    text-align: center;
  }
  .changeIndentityBox > div:nth-of-type(2) {
    margin-left: 10px;
  }
  .vipList {
    font-size: 15px;
  }
  .accountWalletAddress {
    margin: 20px 12px auto 12px;
    text-align: left;
    font-size: 16px;
    color: #333333;
    font-family: PingFang SC;
  }
  .accountWalletAddress > p {
    margin-bottom: 12px;
  }
  .addressBox {
    display: flex;
    position: relative;
    > span {
      display: inline-block;
      min-width: 50px;
    }
  }
  .btn {
    position: absolute;
    right: -6px;
    color: #6376f7;
    cursor: pointer;
  }
  .money {
    font-size: 16px;
    color: #f25e5e;
    font-weight: 500;
  }
  .addressInput > input {
    // border-width: 1px;
    outline: none;
    height: 25px;
    border: 1px solid #aaa;
    border-radius: 5px;
  }
  .nowAddress {
    max-width: 180px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .person_left_bottom {
    width: 300px;
    // height: 584px;
    background-color: #ffffff;
    border-radius: 10px;
    font-size: 16px;
    position: absolute;
    top: 530px;
    margin-bottom: 10px;
  }
  .fourList {
    margin: 22px 12px auto 12px;
  }
  .fourList > li {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
  }
  .person_right {
    width: 1120px;
    height: 1020px;
    margin-left: 20px;
    // padding: 25px 50px auto 50px;
    z-index: 99;
  }
  .circle {
    display: block;
    width: 238px;
    height: 238px;
    border-radius: 50%;
    background-color: #e6ebff;
    position: absolute;
    top: 363px;
    right: 57px;
  }
  .hollowCircle {
    width: 67px;
    height: 67px;
    border: 4px solid #ffe1be;
    border-radius: 50%;
    opacity: 1;
    position: absolute;
    top: 296px;
    right: 57px;
  }
  .money_number {
    font-size: 22px;
    font-weight: bold;
  }
  .leftContent {
    font-size: 16px;
    color: #333333;
  }
  .clearCache {
    background-color: #e7e6e6;
    border-style: none;
    width: 80px;
    height: 30px;
    border-radius: 5px;
    position: absolute;
    top: 250px;
    left: 10px;
    cursor: pointer;
    outline: none;
  }
  .clearCache:hover {
    background-color: #cfcece;
  }
  .readyToClear {
    width: 200px;
    height: 100px;
    border-radius: 10px;
    background-color: #e7e7e7;
    position: absolute;
    bottom: 50px;
  }
}
</style>
<template>
  <div class="person_Center">
    <div class="person_left_top">
      <ul>
        <li
          :class="['menuItem', item.key == $route.path ? 'active' : '']"
          v-for="item in menuList"
          :key="item.key"
          @click="choseMenu(item)"
        >
          {{ item.text }}
        </li>
      </ul>
    </div>
    <div
      class="person_left_bottom"
    >
      <el-button type="text" @click="goToLaobanliang"
        ><span style="color: #6376f7">进入老板良</span>
      </el-button>
    </div>

    <div class="person_right">
      <router-view />
    </div>
    <span class="circle"></span>
    <span class="hollowCircle"></span>
    <!-- <div class="center_left">
      <span class="personInfo">个人信息</span>
      <div class="headImg">
        <img
          :src="
            userData.logo_url
              ? userData.logo_url
              : require('../../assets/logo.png')
          "
          alt=""
        />
      </div>
      <p class="userName">{{ userData.name ? userData.name : "" }}</p>
      <ul class="person_userInfo">
        <li class="vip" v-if="userData.cloud_vip == 0">
          柜柜云仓：您还不是柜柜云仓会员
        </li>
        <li class="vip" v-if="userData.cloud_vip == 1">
          柜柜云仓：<span
            ><img src="../../assets/icon_lowtvip.png" alt="" /></span
          >&nbsp;云仓银牌会员
        </li>
        <li class="vip" v-if="userData.cloud_vip == 2">
          柜柜云仓：<span><img src="../../assets/icon_vip.png" alt="" /></span
          >&nbsp;云仓金牌会员
        </li>
        <li class="userPhone">
          柜柜账号：{{ userData.phone ? userData.phone : "" }}
        </li>
        <li class="guiguiWallet">
          柜柜钱包：<span
            >￥{{
              !userData.wallet || userData.wallet == 0.0 ? "0" : userData.wallet
            }}</span
          >
        </li>
      </ul>
      <div class="manageAddress">
        <span>发货地址：</span>
        <div class="addressInput" v-show="inputShow">
          <input type="text" v-model="myAddress.address" />
        </div>
        <div class="nowAddress" v-show="!inputShow">
          {{ myAddress.address }}
        </div>
        &nbsp;&nbsp;&nbsp;
        <span class="btn" @click="changeAddress">{{
          inputShow ? "保存" : "管理"
        }}</span>
      </div>
      <div class="downApp">
        <span>柜柜APP软件</span
        ><span class="downBtn" @click="downApp">下载</span>
      </div>
      <div class="logout" @click="logout"><span>退出登录</span></div>
    </div> -->
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import cloudSupplier from "./cloudSupplier";
export default {
  components: {
    cloudSupplier,
  },
  data() {
    return {
      menuList: [{
        key: '/personalCenter/info',
        text: '个人资料'
      }, {
        key: '/personalCenter/orders',
        text: '我的订单'
      }, {
        key: '/personalCenter/shopcar',
        text: '购物车'
      }],
      inputShow: false,
      headBg: require("../../assets/center_bg.png"),
      myAddress: {},
    };
  },
  computed: {
    ...mapState({
      userData: "saveMyUserInfo",
      mainAcounts: "mainAcounts",
      identityMode: "identityMode",
    }),
    ...mapGetters({
      mode: "mode",
      staffInfo: "staffInfo",
    }),
    // vipKind(){
    //   return this.userData.cloud_vip
    // },
    price_count() {
      // console.log(this.supplierInfo.color_price?this.supplierInfo.color_price.split(',').length:0)
      // console.log(this.supplierInfo.base_price?this.supplierInfo.base_price.split(',').length:0)
      // console.log(this.supplierInfo.color_price?this.supplierInfo.color_price.split(',').length:0+(this.supplierInfo.base_price?this.supplierInfo.base_price.split(',').length:0))
      return this.supplierInfo.color_price
        ? this.supplierInfo.color_price.split(",").length
        : 0 +
            (this.supplierInfo.base_price
              ? this.supplierInfo.base_price.split(",").length
              : 0);
    },
    supplierInfo() {
      return (
        this.$store.state.supplierInfo || {
          name: "",
          deposit: 0,
        }
      );
    },
  },
  methods: {
    choseMenu(menuItem) {
      this.$router.replace(menuItem.key);
    },
    goToLaobanliang() {
      window.open("http://www.guigui.com.cn/#/personalCenter");
    },
    changeIndentity(e) {
      if (!this.mainAcounts.length) {
        this.$message("您还不是任何人的员工");
        return;
      }
      let indentity = Number(e.target.value);
      this.$store.commit("setIdentity", indentity);
      if (this.mainAcounts.length && indentity) {
        // 获取主账号
        this.$get(
          "/system/wechat_app/user_info",
          {
            uid: this.mainAcounts[0].uid,
          },
          (res) => {
            this.$store.commit("changeMainAcountInfo", res.data);
          }
        );
        // 获取主账号供应商信息
        this.$store.commit("changeSupplierInfo", this.mainAcounts[0].uid);
      }
      // 切回主账号
      if (indentity == 0) {
        let userData = JSON.parse(localStorage.data);
        this.$store.commit("changeSupplierInfo", userData.id);
        this.$store.commit("changeMainAcountInfo", "");
      }
    },
    changeMainAcount(e) {
      let index = e.target.value;
      let nowMain = this.mainAcounts[index];
      // 获取主账号信息，赋值给当前userInfo
      this.$get(
        "/system/wechat_app/user_info",
        {
          uid: nowMain.uid,
        },
        (res) => {
          this.$store.commit("changeMainAcountInfo", res.data);
        }
      );
      this.$store.commit("changeSupplierInfo", nowMain.uid);
    },
    clearCache() {
      this.$confirm("此操作将清除浏览器缓存, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.removeItem("data");
          window.location.href = "/";
          this.$message({
            type: "success",
            message: "清除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    dev() {
      this.$message("开发中");
      return;
    },
    toQuotation() {
      this.$message("开发中");
    },
    ...mapMutations(["logout"]),
    changeAddress(e) {
      this.inputShow = !this.inputShow;
      let isSave = e.target.dataset.name;
      if (!this.inputShow) {
        if (this.myAddress.hasOwnProperty("id") && this.myAddress.address) {
          // 目前地址不为空
          // this.axios
          //   .post("https://ggtools.thinkerx.com/erp/update_address", {
          //     id: this.myAddress.id,
          //     uid: this.userData.id,
          //     name: this.myAddress.name,
          //     phone: this.userData.phone,
          //     address: this.myAddress.address,
          //     default: 1,
          //   })
          //   .then((res) => {
          //     this.$message.success("地址保存成功");
          //   });
          this.$post(
            "/py/erp/update_address",
            {
              id: this.myAddress.id,
              uid: this.userData.id,
              name: this.myAddress.name,
              phone: this.userData.phone,
              address: this.myAddress.address,
              default: 1,
            },
            (res) => {
              this.$message.success("地址保存成功");
            }
          );
        } else {
          // 没有地址，填写地址不为空
          if (this.myAddress.address) {
            // this.axios
            //   .post("https://ggtools.thinkerx.com/erp/add_address", {
            //     uid: this.userData.id,
            //     name: this.userData.name,
            //     phone: this.userData.phone,
            //     address: this.myAddress.address,
            //     default: 1,
            //   })
            //   .then((res) => {
            //     this.$message.success("地址保存成功");
            //   });

            this.$post(
              "/py/erp/add_address",
              {
                uid: this.userData.id,
                name: this.userData.name,
                phone: this.userData.phone,
                address: this.myAddress.address,
                default: 1,
              },
              (res) => {
                this.$message.success("地址保存成功");
              }
            );
          }
        }
      }
    },
    // logout(){
    //     localStorage.removeItem('data')
    //     window.location.search = ''
    //     this.$message("退出登录成功")
    //     this.$emit("logout")
    // },
    toCharge() {
      this.$message("即将上线，敬请期待");
    },
    downApp() {
      location.href = "https://www.eggrj.com/download.html";
    },
  },
  async mounted() {
    let that = this;
    // if(localStorage.data){
    //     await this.axios('https://guigui.admin.thinkerx.com/wechat_app/user_info?phone='+JSON.parse(localStorage.data).phone).then(res=>{
    //         localStorage.data=JSON.stringify(res.data.data)
    //         this.userData = JSON.parse(localStorage.data)
    //     })
    // }
    // this.userData = JSON.parse(localStorage.data)
    // this.$post('',{},res => {
    //     console.log(res)
    // })
    if (this.userData.id) {
      // this.axios
      //   .get("https://ggtools.thinkerx.com/erp/get_address", {
      //     params: {
      //       uid: this.userData.id,
      //       condition: "default",
      //     },
      //   })
      //   .then((res) => {
      //     if (res.data.data.length) {
      //       that.myAddress = res.data.data[0];
      //     }
      //   });
      this.$get(
        "/py/erp/get_address",
        {
          uid: this.userData.id,
          condition: "default",
        },
        (res) => {
          if (res.data.length) {
            that.myAddress = res.data[0];
          }
        }
      );
    }
  },
};
</script>
